import { IStandardConfigurationConstructionType } from '../../interfaces/istandard-configuration-construction-type';
import { ConstructionType } from '../construction-type';
import { StandardConfiguration } from '../standard-configuration';

export class StandardConfigurationConstructionTypeBase {
  StandardConfigurationConstructionTypeId: number;
  StandardConfigurationId: number | null;
  ConstructionTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstructionType?: ConstructionType;
  StandardConfiguration?: StandardConfiguration;

  constructor(item?: IStandardConfigurationConstructionType) {
    if (item) {

      this.StandardConfigurationConstructionTypeId = item.StandardConfigurationConstructionTypeId;
      this.StandardConfigurationId = item.StandardConfigurationId;
      this.ConstructionTypeId = item.ConstructionTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstructionType = new ConstructionType(item.ConstructionType);
      this.StandardConfiguration = new StandardConfiguration(item.StandardConfiguration);
    }
  }
}